import {getStats} from '@api/test';
import Image from '@components/Image';
import {actions, store} from '@components/Test/Context';
import Option from '@components/Test/Option';
import {TEXT} from '@constants/test';
import type {Option as OptionType, Question as QuestionType} from '@interfaces/Test';
import classNames from 'classnames';
import type {ReactElement, ReactNode} from 'react';
import {useContext, useEffect, useState} from 'react';

interface Props extends QuestionType {
    children?(): ReactNode | null;
}

export default function Question(props: Props): ReactElement<Props> {
    const {currentState, dispatch} = useContext(store);
    const [isStatsLoading, setIsStatsLoading] = useState(false);
    const [hasStatsLoaded, setHasStatsLoaded] = useState(false);
    const showStats = props.showStats || currentState.showStats;

    const optionsClasses = classNames({
        'test-question__options': true,
        'test-question__options--vertical': props.isVertical,
    });

    useEffect(() => {
        if (showStats) {
            setIsStatsLoading(true);
            void getStats(currentState.id, currentState.questionNum)
                .then(({data}) => {
                    dispatch({type: actions.writeStats, data});
                    setHasStatsLoaded(true);
                })
                .finally(() => {
                    setIsStatsLoading(false);
                });
        }
    }, []);

    return (
        <div className="test-question__content">
            {props.text ? (
                <div
                    className="test-question__text"
                    dangerouslySetInnerHTML={{__html: props.text}}
                />
            ) : null}
            {props.image ? <Image src={props.image} className="test-question__image" /> : null}
            {props.children?.()}
            <div className={optionsClasses}>
                {props.options.map((item: OptionType) => (
                    <Option
                        key={item.id}
                        showStats={showStats}
                        questionType={props.type ?? TEXT}
                        isStatsLoading={isStatsLoading}
                        hasStatsLoaded={hasStatsLoaded}
                        {...item}
                    />
                ))}
            </div>
            {currentState.isChecked && currentState.comment ? (
                <div
                    className="test-question__comment"
                    dangerouslySetInnerHTML={{__html: currentState.comment}}
                />
            ) : null}
        </div>
    );
}
